export const ROLE_PERMISSIONS = {
  1: {
    name: 'ADMIN',
    description: 'Administrador',
    routes: [
      // Rutas exclusivas de admin
      'Empresas',
      'Empresa',
      'Usuario',
      'Dispositivos',
      'Resenas',
      'ajustes/diasdisponibles',
      'Verifyusers',
      // Rutas compartidas con otros roles
      'Usuarios',
      'Professionals',
      'Professional',
      'Productos',
      'Pacientes',
      'Paciente',
      'MedyolaPaciente',
      'Buscadopaciente',
      'Mensajeria',
      'MessagingCreate',
      'MessagingDetails',
      'NuevoMensaje',
      'Videoconsulta',
      'NuevaVideo',
      'Calendario',
      'CalendarioEspecialidad',
      'VerCita',
      'Facturacion',
      'Reportes',
      'Packscontratados',
      'Suscripcionescontratadas',
      'ajustes/talonario',
      'ajustes/firma',
      'ajustes/agenda',
      'ajustes/especialidades',
      'ajustes/diasnodisponibles',
      'ajustes/valorespersonalizados',
      'configServicios',
      'ajustes/videoconsultas',
      'ajustes/servicios',
      'ajustes/packs',
      'ajustes/cupones',
      'ajustes/landing',
      'ajustes/recepcionista',
      'ajustes/company-config'
    ]
  },

  2: {
    name: 'PROFESSIONAL',
    description: 'Profesional',
    routes: [
      'Receta',
      'Nuevareceta',
      'Reemitir',
      'prescriptionsFilteredList',
      'Videoconsulta',
      '/account/two-factor-authentication',
      'Account2FAView',
      'NuevaVideo',
      'Calendario',
      'CalendarioEspecialidad',
      'Mensajeria',
      'MessagingCreate',
      'MessagingDetails',
      'NuevoMensaje',
      'Pacientes',
      'NuevoPaciente',
      'Paciente',
      'MedyolaPaciente',
      'Buscadopaciente',
      'Facturacion',
      'Reportes',
      'Packscontratados',
      'Suscripcionescontratadas',
      'ajustes/talonario',
      'ajustes/firma',
      'ajustes/agenda',
      'ajustes/especialidades',
      'ajustes/diasnodisponibles',
      'ajustes/valorespersonalizados',
      'configServicios',
      'ajustes/videoconsultas',
      'ajustes/servicios',
      'ajustes/packs',
      'ajustes/cupones',
      'ajustes/landing',
      'ajustes/recepcionista',
      'ajustes/company-config'
    ]
  },

  3: {
    name: 'RECEPTIONIST',
    description: 'Recepcionista',
    routes: [
      // Rutas exclusivas de recepcionista
      'NuevoUsuario',
      'NuevoPaciente',
      // Rutas compartidas
      'Usuarios',
      'Professionals',
      'Professional',
      'Productos',
      'Pacientes',
      'Paciente',
      'MedyolaPaciente',
      'Buscadopaciente',
      'Mensajeria',
      'MessagingCreate',
      'MessagingDetails',
      'NuevoMensaje',
      'Videoconsulta',
      'NuevaVideo',
      'Calendario',
      'CalendarioEspecialidad',
      'VerCita',
      'Facturacion',
      'Reportes',
      'Packscontratados',
      'Suscripcionescontratadas',
      'ajustes/talonario',
      'ajustes/firma',
      'ajustes/agenda',
      'ajustes/especialidades',
      'ajustes/diasnodisponibles',
      'ajustes/valorespersonalizados',
      'configServicios',
      'ajustes/videoconsultas',
      'ajustes/servicios',
      'ajustes/packs',
      'ajustes/cupones',
      'ajustes/landing',
      'ajustes/recepcionista',
      'ajustes/company-config'
    ]
  },

  4: {
    name: 'RRHH',
    description: 'Recursos Humanos',
    routes: [
      'Usuarios',
      'Professionals',
      'Professional',
      'Productos',
      'Pacientes',
      'Paciente',
      'MedyolaPaciente',
      'Buscadopaciente',
      'Mensajeria',
      'MessagingCreate',
      'MessagingDetails',
      'NuevoMensaje',
      'Videoconsulta',
      'NuevaVideo',
      'Calendario',
      'CalendarioEspecialidad',
      'VerCita',
      'Facturacion',
      'Reportes',
      'Packscontratados',
      'Suscripcionescontratadas',
      'ajustes/talonario',
      'ajustes/firma',
      'ajustes/agenda',
      'ajustes/especialidades',
      'ajustes/diasnodisponibles',
      'ajustes/valorespersonalizados',
      'configServicios',
      'ajustes/videoconsultas',
      'ajustes/servicios',
      'ajustes/packs',
      'ajustes/cupones',
      'ajustes/landing',
      'ajustes/recepcionista',
      'ajustes/company-config'
    ]
  },

  5: {
    name: 'PATIENT',
    description: 'Paciente',
    routes: [
      'myVideoconsultations',
      'myMessages',
      'patients/documents/upload',
      'DocumentUpload',
      'myPrescriptions',
      'mySubscriptions',
      'myDocuments',
      'sendUsMessage',
      'settings/beneficiaries',
      'settings/beneficiary',
      'hiringService',
      'hiring/service'
    ]
  }
};

export const PUBLIC_ROUTES = [
  'Login',
  'Logout',
  'Signup',
  'Triage',
  'Blockchain',
  'FAQ',
  'ResetPassword',
  'ActivarCuenta',
  'account',
  'Account',
  'AccountView',
  'AccountPasswordView',
  'LinkPacienteProfesional',
  'FirmaLink',
  'LoginIconnecta',
  'LoginMediktor',
  'Booking',
  'Dashboard',
  'Root',
  'Landing',
  'NotFound',
  'AccessDenied',
  'ServerError',
  'Recetaelectronica',
  'Regitrosreceta',
  'payAppointment',
  'LandingPage',
  'GoogleAuthenticatorRedirect',
  'Media',
  'chat',
  'Ayuda',
  'Contacto',
  'Perfil',
  'Notificaciones',
  'Reserva'
];

export const isPublicRoute = (routeName) => {
  return PUBLIC_ROUTES.includes(routeName);
};

export const hasRoleAccessToRoute = (routeName, userRole) => {
  if (isPublicRoute(routeName)) {
    return true;
  }

  if (!userRole || !ROLE_PERMISSIONS[userRole]) {
    return false;
  }

  return ROLE_PERMISSIONS[userRole].routes.includes(routeName);
};

export const getRoutesForRole = (userRole) => {
  if (!userRole || !ROLE_PERMISSIONS[userRole]) {
    return [];
  }

  return ROLE_PERMISSIONS[userRole].routes;
};

export const getRoleInfo = (userRole) => {
  return ROLE_PERMISSIONS[userRole] || null;
};
